import moment from 'moment'
import React from 'react'
import Link from 'redux-first-router-link'

import ManagedAccordion from 'shared/components/ui/ManagedAccordion'
import { Loader, Menu } from 'util/ui'

import Actions from '../../../shared/LinkedResource/Actions'
import Key from '../../../shared/LinkedResource/Key'
import Row from '../../../shared/LinkedResource/Row'
import Title from '../../../shared/LinkedResource/Title'
import Icon from './Icon'

function formatDate(date, withTime = false) {
  if (!date) return ''
  const asDate = new Date(date)
  const displayYear = asDate.getFullYear() !== new Date().getFullYear()
  return moment(date).format(
    `D MMM${displayYear ? " 'YY" : ''}${withTime ? ', H:mmA' : ''}`
  )
}
export default function LinkedJiraServerIssue({
  issue,
  issue: {
    externalId,
    title,
    key,
    fields: {
      assignee,
      created,
      duedate,
      labels,
      project: {
        avatarUrls: { '48x48': projectAvatarUrl } = {},
        key: projectKey,
        name: project,
      } = {},
      resolution,
      status: { name: status } = {},
      summary,
      issuetype: { iconUrl: typeIconUrl, name: type } = {},
      updated,
    } = {},
    loading,
    self,
    url,
  },
  initiallyActive,
  fieldsToDisplay: {
    assignee: displayAssignee,
    created: displayCreated,
    dueDate: displayDueDate,
    labels: displayLabels,
    project: displayProject,
    resolution: displayResolution,
    status: displayStatus,
    type: displayType,
    updated: displayUpdated,
  },
  onUnlink,
}) {
  const matches = self && self.match(/^https?:\/\/[^/]+/)
  const site = matches ? matches[0] : ''
  const {
    avatarUrls: { '48x48': assigneeAvatarUrl } = {},
    name: assigneeName,
  } =
    assignee || {}
  const { name: resolutionName } = resolution || {}
  const summaryWithKey = `[${key}] ${summary}`
  return (
    <ManagedAccordion
      as={Menu}
      collapsed
      fluid
      initiallyActive={initiallyActive}
      styled
      title={<Title>{key ? summaryWithKey : title}</Title>}
      vertical
    >
      {(!issue || loading) && <Loader active inline="centered" />}
      {issue &&
        !loading && (
          <React.Fragment>
            <Row>
              <Key>Issue: </Key>
              <Link rel="noopener noreferrer" target="_blank" to={url}>
                {summaryWithKey}
              </Link>
            </Row>
            {type &&
              displayType && (
                <Row>
                  <Key>Type: </Key>
                  <Link
                    rel="noopener noreferrer"
                    target="_blank"
                    to={`${site}/issues/?jql=issuetype%20%3D%20%22${type}%22`}
                  >
                    <Icon src={typeIconUrl} />
                    {type}
                  </Link>
                </Row>
              )}
            {status &&
              displayStatus && (
                <Row>
                  <Key>Status: </Key>
                  <Link
                    rel="noopener noreferrer"
                    target="_blank"
                    to={`${site}/issues/?jql=status%20%3D%20%22${status}%22`}
                  >
                    {status}
                  </Link>
                </Row>
              )}
            {resolutionName &&
              displayResolution && (
                <Row>
                  <Key>Resolution: </Key>
                  {resolutionName}
                </Row>
              )}
            {duedate &&
              displayDueDate && (
                <Row>
                  <Key>Due: </Key>
                  {formatDate(duedate)}
                </Row>
              )}
            {created &&
              displayCreated && (
                <Row>
                  <Key>Created: </Key>
                  {formatDate(created, true)}
                </Row>
              )}
            {updated &&
              displayUpdated && (
                <Row>
                  <Key>Last updated: </Key>
                  {formatDate(updated, true)}
                </Row>
              )}
            {assigneeName &&
              displayAssignee && (
                <Row>
                  <Key>Assignee: </Key>
                  <Link
                    rel="noopener noreferrer"
                    target="_blank"
                    to={`${site}/secure/ViewProfile.jspa?name=${assigneeName}`}
                  >
                    <Icon src={assigneeAvatarUrl} />
                    @{assigneeName}
                  </Link>
                </Row>
              )}
            {labels &&
              labels.length > 0 &&
              displayLabels && (
                <Row>
                  <Key>Labels: </Key>
                  {labels.map((label, index) => {
                    return [
                      <Link
                        key={label}
                        rel="noopener noreferrer"
                        target="_blank"
                        to={`${site}/issues/?jql=labels%20%3D%20%22${label}%22`}
                      >
                        {label}
                      </Link>,
                      index + 1 !== labels.length && ', ',
                    ]
                  })}
                </Row>
              )}

            {project &&
              displayProject && (
                <Row>
                  <Key>Project: </Key>
                  <Link
                    rel="noopener noreferrer"
                    target="_blank"
                    to={`${site}/browse/${projectKey}`}
                  >
                    <Icon src={projectAvatarUrl} />
                    {project}
                  </Link>
                </Row>
              )}
            <Actions
              id={externalId}
              actions={[
                {
                  action: onUnlink,
                  icon: 'unlink',
                  text: 'Unlink',
                },
              ]}
            />
          </React.Fragment>
        )}
    </ManagedAccordion>
  )
}
